// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Global component layer — 2026 polish.
 * Restyles Bootstrap + the legacy pcoded template through design tokens only.
 * Loaded after theme.css; must work in BOTH html.light and html.dark.
 */

/* === Base === */
html {
  font-family: var(--font-sans);
}

body {
  background: var(--page-bg) !important;
  color: var(--foreground) !important;
  font-family: var(--font-sans) !important;
  transition: background-color var(--transition-slow), color var(--transition-slow);
}

::selection {
  background: var(--primary-soft);
  color: var(--foreground);
}

/* Custom scrollbars — thin, unobtrusive, theme-aware */
* {
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) transparent;
}
*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
*::-webkit-scrollbar-track {
  background: transparent;
}
*::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: var(--radius-full);
}
*::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-thumb-hover);
}

/* Accessible focus — only for keyboard users */
:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--ring) !important;
  border-radius: var(--radius-sm);
}

h1, h2, h3, h4, h5, h6 {
  color: var(--foreground);
  letter-spacing: -0.02em;
  font-weight: 600;
}

a {
  color: var(--primary);
  transition: color var(--transition-fast);
}
a:hover {
  color: var(--primary-hover);
}

code, pre, .font-mono {
  font-family: var(--font-mono);
}

/* === Layout wrapper === */
/* Heights live in responsive.css (the shell is a flex column); this layer only
   paints. */
.labelflow-theme {
  background: var(--page-bg);
}

.labelflow-main {
  background: var(--page-bg);
}

.labelflow-container {
  padding: 1.25rem;
  max-width: 100%;
}

.pcoded-main-container {
  background: var(--page-bg) !important;
}

/* === Header — frosted, sticky-feeling app bar === */
.pcoded-header.navbar,
.pcoded-header.header-dark,
.pcoded-header.header-labelflow {
  background: var(--header) !important;
  color: var(--header-foreground) !important;
  border-bottom: 1px solid var(--header-border) !important;
  box-shadow: none !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.pcoded-header .input-group .input-group-text,
.pcoded-header a,
.pcoded-header .dropdown-toggle,
.pcoded-header .h-drop {
  color: var(--header-foreground) !important;
  opacity: 0.85;
  font-weight: 500;
  transition: color var(--transition-fast), opacity var(--transition-fast);
}

.pcoded-header .input-group .input-group-text:hover,
.pcoded-header a:hover,
.pcoded-header .dropdown-toggle:hover,
.pcoded-header .h-drop:hover {
  color: var(--primary) !important;
  opacity: 1;
}

.pcoded-header .dropdown-menu.profile-notification {
  background: var(--popover) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius) !important;
  box-shadow: var(--shadow-lg) !important;
  padding: 0.25rem !important;
}

.pcoded-header .dropdown-menu .dropdown-item {
  color: var(--popover-foreground) !important;
  border-radius: var(--radius-sm) !important;
  padding: 0.5rem 0.75rem !important;
  background: transparent !important;
  transition: background-color var(--transition-fast);
}

.pcoded-header .dropdown-menu .dropdown-item:hover,
.pcoded-header .dropdown-menu .dropdown-item:focus {
  background: var(--accent) !important;
  color: var(--accent-foreground) !important;
}

.pcoded-header .dropdown-menu .pro-head {
  background: var(--muted) !important;
  color: var(--foreground) !important;
  border-bottom: 1px solid var(--border) !important;
  padding: 0.75rem 1rem !important;
  border-radius: var(--radius-sm) var(--radius-sm) 0 0 !important;
}

.pcoded-header .dropdown-menu .pro-body {
  padding: 0.25rem !important;
}

.pcoded-header .drp-user .dropdown-toggle {
  color: var(--header-foreground) !important;
}
.pcoded-header .drp-user .dropdown-toggle:hover {
  color: var(--primary) !important;
}

/* === Containers === */
.container,
.container-fluid {
  background: transparent !important;
}

/* === Cards === */
.card {
  background: var(--card) !important;
  color: var(--card-foreground) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius-lg) !important;
  box-shadow: var(--shadow-sm) !important;
  transition: border-color var(--transition), box-shadow var(--transition), transform var(--transition);
}

.card-header,
.card .card-header {
  background: transparent !important;
  color: var(--foreground) !important;
  border-bottom: 1px solid var(--border) !important;
  border-radius: var(--radius-lg) var(--radius-lg) 0 0 !important;
  font-weight: 600;
}

.card-body {
  background: transparent !important;
  color: var(--card-foreground) !important;
}

/* The legacy theme hardcodes \`.card .card-header h5 { color: white }\` (and a
   bare \`h5 { color: white }\`), which is invisible on a light card. The Card
   atom's header renders exactly that h5, so titles must follow the token.
   Specificity has to match the legacy \`.card .card-header h5\` to win. */
.card .card-header h5,
.card .card-header h6,
.card-header h5,
.card-header h6 {
  color: var(--foreground) !important;
}

/* === Forms === */
.form-control,
.form-select,
input[type="text"],
input[type="email"],
input[type="password"],
input[type="number"],
input[type="search"],
select,
textarea {
  background: var(--background) !important;
  border: 1px solid var(--input) !important;
  border-radius: var(--radius-sm) !important;
  color: var(--foreground) !important;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.form-control::placeholder,
textarea::placeholder,
input::placeholder {
  color: var(--muted-foreground) !important;
  opacity: 0.8;
}

.form-control:focus,
.form-select:focus,
input:focus,
select:focus,
textarea:focus {
  border-color: var(--primary) !important;
  box-shadow: 0 0 0 3px var(--ring) !important;
  outline: none !important;
  background: var(--card) !important;
}

/*
 * Opt-out for a text field that is NOT a standalone form control.
 *
 * The rules above are \`!important\`, so a page-level \`border: none\` on a textarea
 * loses to them silently. Where a field is only one part of a larger composed
 * surface that draws its own border and focus ring — the assistant composer — the
 * global chrome paints a second bordered box INSIDE that surface and stacks a
 * second focus ring on top of the parent's. Give such a field \`lf-field-bare\` and
 * let its container own the chrome. This is the supported way out; do not fight
 * the rules above with page-level \`!important\`.
 */
textarea.lf-field-bare,
input.lf-field-bare,
textarea.lf-field-bare:focus,
input.lf-field-bare:focus {
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  outline: none !important;
}

.form-label,
label {
  color: var(--foreground);
}

.form-text,
small.text-muted,
.text-muted {
  color: var(--muted-foreground) !important;
}

/* Switches & checks */
.form-check-input {
  background-color: var(--secondary) !important;
  border-color: var(--border-strong) !important;
}
.form-check-input:checked {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}
.form-check-input:focus {
  box-shadow: 0 0 0 3px var(--ring) !important;
}
.form-check-label {
  color: var(--foreground);
}

/* Range sliders */
.form-range::-webkit-slider-thumb {
  background: var(--primary) !important;
}
.form-range::-moz-range-thumb {
  background: var(--primary) !important;
}
.form-range::-webkit-slider-runnable-track {
  background: var(--secondary) !important;
  border-radius: var(--radius-full);
}
.form-range::-moz-range-track {
  background: var(--secondary) !important;
  border-radius: var(--radius-full);
}

/* === Buttons === */
.btn {
  border-radius: var(--radius-sm) !important;
  font-weight: 500;
  transition: all var(--transition-fast) !important;
}
.btn:active {
  transform: translateY(1px);
}
.btn:focus,
.btn:focus-visible {
  box-shadow: 0 0 0 3px var(--ring) !important;
}
.btn:disabled {
  opacity: 0.45;
}

.btn-primary {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
  color: var(--primary-foreground) !important;
}
.btn-primary:hover:not(:disabled) {
  background: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
  color: var(--primary-foreground) !important;
}

.btn-secondary {
  background: var(--secondary) !important;
  border-color: var(--border) !important;
  color: var(--secondary-foreground) !important;
}
.btn-secondary:hover:not(:disabled) {
  background: var(--secondary-hover) !important;
  border-color: var(--border-strong) !important;
  color: var(--foreground) !important;
}
.btn-secondary.active {
  background: var(--primary-soft) !important;
  border-color: var(--primary) !important;
  color: var(--primary) !important;
}

.btn-success {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
  color: var(--primary-foreground) !important;
}
.btn-success:hover:not(:disabled) {
  background: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.btn-danger {
  background: var(--destructive) !important;
  border-color: var(--destructive) !important;
  color: var(--destructive-foreground) !important;
}
.btn-danger:hover:not(:disabled) {
  background: var(--destructive-hover) !important;
  border-color: var(--destructive-hover) !important;
}

.btn-outline-success {
  background: transparent !important;
  border-color: var(--primary) !important;
  color: var(--primary) !important;
}
.btn-outline-success:hover:not(:disabled) {
  background: var(--primary-soft) !important;
  color: var(--primary) !important;
}
.btn-outline-success.active {
  background: var(--primary) !important;
  color: var(--primary-foreground) !important;
}

.btn-outline-danger {
  background: transparent !important;
  border-color: var(--destructive) !important;
  color: var(--destructive) !important;
}
.btn-outline-danger:hover:not(:disabled) {
  background: var(--destructive-soft) !important;
  color: var(--destructive) !important;
}

.btn-outline-secondary {
  background: transparent !important;
  border-color: var(--border-strong) !important;
  color: var(--secondary-foreground) !important;
}
.btn-outline-secondary:hover:not(:disabled) {
  background: var(--secondary) !important;
  color: var(--foreground) !important;
}

.btn-outline-primary {
  background: transparent !important;
  border-color: var(--primary) !important;
  color: var(--primary) !important;
}
.btn-outline-primary:hover:not(:disabled) {
  background: var(--primary-soft) !important;
  color: var(--primary) !important;
}

/* === Badges === */
.badge {
  border-radius: var(--radius-full) !important;
  font-weight: 500;
}
.badge.bg-light {
  background: var(--secondary) !important;
  color: var(--secondary-foreground) !important;
  border: 1px solid var(--border);
}
/* text-dark inside themed badges must follow the theme, not stay black */
.badge.bg-light.text-dark {
  color: var(--secondary-foreground) !important;
}

/* === Atom: Badge (components/Atoms/Badge.jsx) === */
.lf-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.2;
  border-radius: var(--radius-full);
  border: 1px solid var(--border);
  background: var(--secondary);
  color: var(--secondary-foreground);
  white-space: nowrap;
}
.lf-badge--primary,
.lf-badge--success {
  background: var(--primary-soft);
  color: var(--primary);
  border-color: transparent;
}
.lf-badge--warning {
  background: var(--warning-soft);
  color: var(--warning);
  border-color: transparent;
}
.lf-badge--info {
  background: var(--info-soft);
  color: var(--info);
  border-color: transparent;
}
.lf-badge--danger {
  background: var(--destructive-soft);
  color: var(--destructive);
  border-color: transparent;
}
.lf-badge--neutral {
  background: var(--secondary);
  color: var(--muted-foreground);
}

/* === Atom: IconButton (components/Atoms/IconButton.jsx) === */
.lf-icon-btn {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--foreground);
  width: 34px;
  height: 34px;
  border-radius: var(--radius-full);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-fast);
}
.lf-icon-btn:hover:not(:disabled) {
  border-color: var(--primary);
  color: var(--primary);
  background: var(--primary-soft);
}
.lf-icon-btn--active {
  border-color: var(--primary);
  color: var(--primary);
  background: var(--primary-soft);
}
.lf-icon-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* === Brand: the logo lockup (components/Atoms/Logo.jsx) ===
   \`--lf-logo-size\` is set inline by the component and is the MARK's size; the
   wordmark is derived from it so one number scales the whole lockup. Two-tone
   on purpose: the accent belongs on the half that carries the name, and a
   single emerald wordmark sat at poor contrast on the light theme. */
.lf-logo {
  display: inline-flex;
  align-items: center;
  gap: 0.46em;
  line-height: 1;
  white-space: nowrap;
}

.lf-logo__mark {
  display: block;
  flex: 0 0 auto;
  color: var(--primary);
}

.lf-logo__word {
  font-family: var(--font-sans);
  font-size: calc(var(--lf-logo-size, 26px) * 0.8);
  font-weight: 700;
  letter-spacing: -0.022em;
}

.lf-logo__word-label {
  color: var(--foreground);
}

.lf-logo__word-flow {
  color: var(--primary);
}

/* === Header: language switch (EN/KO) ===
   Same pill geometry as .lf-icon-btn, but carries a text label instead of an
   icon so the current language is readable at a glance. */
.lf-lang-btn {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--foreground);
  min-width: 34px;
  height: 34px;
  padding: 0 0.5rem;
  border-radius: var(--radius-full);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-sans);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: all var(--transition-fast);
}
.lf-lang-btn:hover:not(:disabled) {
  border-color: var(--primary);
  color: var(--primary);
  background: var(--primary-soft);
}

/* === Atom: ghost button variant === */
.btn-ghost {
  background: transparent !important;
  border-color: transparent !important;
  color: var(--muted-foreground) !important;
}
.btn-ghost:hover:not(:disabled) {
  background: var(--secondary) !important;
  color: var(--foreground) !important;
}

/* === Tables === */
.table {
  color: var(--foreground) !important;
  --bs-table-bg: transparent;
  --bs-table-color: var(--foreground);
}
.table thead th {
  background: var(--muted) !important;
  color: var(--muted-foreground) !important;
  border-color: var(--border) !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  font-size: 0.72rem;
  letter-spacing: 0.05em;
}
.table tbody td {
  border-color: var(--border) !important;
  color: var(--foreground) !important;
}
.table tbody tr {
  transition: background-color var(--transition-fast);
}
.table tbody tr:hover {
  background: var(--card-hover) !important;
}

/* === Modals === */
.modal-backdrop.show {
  background: var(--overlay) !important;
  opacity: 1 !important;
}
.modal-content {
  background: var(--card) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius-lg) !important;
  box-shadow: var(--shadow-lg) !important;
  color: var(--foreground) !important;
}
.modal-header {
  background: transparent !important;
  border-bottom: 1px solid var(--border) !important;
  border-radius: var(--radius-lg) var(--radius-lg) 0 0 !important;
}
.modal-title {
  color: var(--foreground) !important;
}
.modal-body {
  background: transparent !important;
  color: var(--foreground) !important;
}
.modal-footer {
  background: transparent !important;
  border-top: 1px solid var(--border) !important;
}
.modal .btn-close,
.modal .close {
  color: var(--muted-foreground) !important;
  text-shadow: none;
  opacity: 0.7;
}
.modal .btn-close:hover,
.modal .close:hover {
  opacity: 1;
  color: var(--foreground) !important;
}

/* === Dropdown menus (generic bootstrap) === */
.dropdown-menu {
  background: var(--popover) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius) !important;
  box-shadow: var(--shadow-lg) !important;
  color: var(--popover-foreground) !important;
}
.dropdown-item {
  color: var(--popover-foreground) !important;
}
.dropdown-item:hover,
.dropdown-item:focus {
  background: var(--accent) !important;
  color: var(--accent-foreground) !important;
}
.dropdown-divider {
  border-color: var(--border) !important;
}

/* === Alerts === */
.alert-success {
  background: var(--primary-soft) !important;
  border-color: var(--primary) !important;
  color: var(--foreground) !important;
}
.alert-danger {
  background: var(--destructive-soft) !important;
  border-color: var(--destructive) !important;
  color: var(--foreground) !important;
}
.alert-warning {
  background: var(--warning-soft) !important;
  border-color: var(--warning) !important;
  color: var(--foreground) !important;
}
.alert-info {
  background: var(--info-soft) !important;
  border-color: var(--info) !important;
  color: var(--foreground) !important;
}

/* === Progress === */
.progress {
  background: var(--secondary) !important;
  border-radius: var(--radius-full) !important;
}
.progress-bar {
  background-color: var(--primary) !important;
}

/* === Pagination === */
.page-link {
  background: var(--card) !important;
  border-color: var(--border) !important;
  color: var(--foreground) !important;
}
.page-link:hover {
  background: var(--secondary) !important;
  color: var(--primary) !important;
}
.page-item.active .page-link {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
  color: var(--primary-foreground) !important;
}

/* === Tippy tooltips (react-tippy) ===

   THE BACKGROUND OVERRIDE BELOW DOES NOT PAINT ON ITS OWN, and that was the
   bug. react-tippy defaults \`animateFill: true\`, which puts \`data-animatefill\`
   on the tooltip — and the library's own rule
   \`.tippy-tooltip[data-animatefill]{background-color:transparent}\` then wins,
   because the visible fill is a SEPARATE \`[x-circle]\` element hardcoded to
   #333. So the text colour followed the theme while the background never did.

   In dark mode that passed unnoticed (#ecedee on #333 is 10.8:1). In LIGHT
   mode it was #101418 on #333 — **1.46:1**, against a WCAG AA floor of 4.5.
   The tooltip was effectively invisible, which is exactly how it was reported.

   The atoms now pass \`animateFill={false}\`, so \`.tippy-tooltip\`'s own
   background applies. \`[x-circle]\` is still tokenised here so the styling
   stays correct if anyone ever turns the fill animation back on. */
.tippy-tooltip {
  background-color: var(--popover) !important;
  color: var(--popover-foreground) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius-sm) !important;
  box-shadow: var(--shadow-md) !important;
  font-family: var(--font-sans) !important;
  font-size: 0.75rem !important;
}

/* Belt and braces: the animated fill, if it is ever re-enabled. */
.tippy-tooltip[data-animatefill] {
  background-color: var(--popover) !important;
}
.tippy-tooltip [x-circle] {
  background-color: var(--popover) !important;
}

/* The arrow.
   This used to target \`.tippy-tooltip .arrow-regular\` — a class that appears
   NOWHERE in react-tippy, so it styled nothing. The real element is
   \`[x-arrow]\`, and its colour lives on a border whose SIDE depends on the
   placement, so one rule per placement is the only way to tokenise it. */
.tippy-popper[x-placement^='top'] [x-arrow] {
  border-top-color: var(--popover) !important;
}
.tippy-popper[x-placement^='bottom'] [x-arrow] {
  border-bottom-color: var(--popover) !important;
}
.tippy-popper[x-placement^='left'] [x-arrow] {
  border-left-color: var(--popover) !important;
}
.tippy-popper[x-placement^='right'] [x-arrow] {
  border-right-color: var(--popover) !important;
}

/* === SweetAlert2 — token-aware === */
.swal2-popup {
  background: var(--card) !important;
  color: var(--foreground) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius-lg) !important;
  box-shadow: var(--shadow-lg) !important;
  font-family: var(--font-sans) !important;
}
.swal2-title {
  color: var(--foreground) !important;
}
.swal2-html-container {
  color: var(--muted-foreground) !important;
}
.swal2-toast {
  background: var(--popover) !important;
}
.swal2-timer-progress-bar {
  background: var(--primary) !important;
}
.swal2-input,
.swal2-textarea,
.swal2-select {
  background: var(--background) !important;
  border: 1px solid var(--input) !important;
  color: var(--foreground) !important;
  border-radius: var(--radius-sm) !important;
}

/* === AG Grid (Datatable) dark-compat via tokens === */
.ag-theme-alpine,
.ag-theme-alpine-dark {
  --ag-background-color: var(--card);
  --ag-foreground-color: var(--foreground);
  --ag-header-background-color: var(--muted);
  --ag-header-foreground-color: var(--muted-foreground);
  --ag-border-color: var(--border);
  --ag-row-hover-color: var(--card-hover);
  --ag-odd-row-background-color: transparent;
  --ag-control-panel-background-color: var(--card);
}

/* === Utility === */
.no_data {
  background: var(--muted) !important;
  color: var(--muted-foreground) !important;
}

.text-primary {
  color: var(--primary) !important;
}
.bg-light {
  background: var(--secondary) !important;
  color: var(--secondary-foreground) !important;
}
.border,
.border-top,
.border-bottom,
.border-start,
.border-end {
  border-color: var(--border) !important;
}

/* === Labeling toolbar (labelManagement studios) ===
   Grouped icon/label controls shared by the detection, segmentation and
   classification workspaces. Tokens only — checked in both themes. */
.lf-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
}
.lf-toolbar__spacer {
  flex: 1 1 auto;
  min-width: 0;
}
.lf-toolbar__group {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  background: var(--muted);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}
/* react-tippy wraps every Button atom in a div — keep it out of the layout */
.lf-toolbar__group > div {
  display: flex;
}
.lf-tool-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  height: 32px;
  padding: 0 0.6rem;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--foreground);
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background var(--transition), color var(--transition), border-color var(--transition);
}
.lf-tool-btn i {
  font-size: 0.85rem;
}
.lf-tool-btn--icon {
  width: 32px;
  padding: 0;
}
.lf-tool-btn--ratio {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.02em;
}
.lf-tool-btn:hover:not(:disabled) {
  background: var(--accent);
  color: var(--accent-foreground);
}
.lf-tool-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--ring);
}
.lf-tool-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.lf-tool-btn--active {
  background: var(--primary);
  border-color: var(--primary);
  color: var(--primary-foreground);
}
.lf-tool-btn--active:hover:not(:disabled) {
  background: var(--primary-hover);
  border-color: var(--primary-hover);
  color: var(--primary-foreground);
}
.lf-zoom-readout,
.lf-image-counter {
  min-width: 3.75rem;
  padding: 0 0.25rem;
  text-align: center;
  font-family: var(--font-mono);
  font-size: 0.74rem;
  font-variant-numeric: tabular-nums;
  color: var(--muted-foreground);
  -webkit-user-select: none;
          user-select: none;
}
.lf-toolbar__status {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--primary);
}

/* Below this width the toolbar would wrap to two rows — drop the word labels
   and keep the icons, which stay understandable via their tooltips. */
@media (max-width: 1400px) {
  .lf-tool-btn__label {
    display: none;
  }
  .lf-tool-btn {
    width: 32px;
    padding: 0;
  }
}

/* Destructive variant of the labeling toolbar button. */
.lf-tool-btn--danger:hover:not(:disabled) {
  background: var(--destructive-soft);
  color: var(--destructive);
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme-overrides.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,iBAAiB;AACjB;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,wCAAwC;EACxC,iFAAiF;AACnF;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;EACrB,mDAAmD;AACrD;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,wCAAwC;AAC1C;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;YACY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,qDAAqD;AACrD;;;EAGE,oCAAoC;EACpC,0CAA0C;EAC1C,wDAAwD;EACxD,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;;;;EAIE,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,wEAAwE;AAC1E;;AAEA;;;;EAIE,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,uCAAuC;EACvC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;EAClC,kCAAkC;EAClC,mDAAmD;AACrD;;AAEA;;EAEE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,iDAAiD;EACjD,gCAAgC;EAChC,+DAA+D;AACjE;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;AAC5C;AACA;EACE,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;;EAEE,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,kCAAkC;EAClC,wCAAwC;EACxC,0CAA0C;EAC1C,0CAA0C;EAC1C,uCAAuC;EACvC,qGAAqG;AACvG;;AAEA;;EAEE,kCAAkC;EAClC,mCAAmC;EACnC,iDAAiD;EACjD,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;;;wEAGwE;AACxE;;;;EAIE,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;;;;;;;;;EASE,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,mCAAmC;EACnC,kFAAkF;AACpF;;AAEA;;;EAGE,yCAAyC;EACzC,YAAY;AACd;;AAEA;;;;;EAKE,uCAAuC;EACvC,4CAA4C;EAC5C,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;;;;;;;;;;EAUE;AACF;;;;EAIE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,6CAA6C;EAC7C,6CAA6C;AAC/C;AACA;EACE,2CAA2C;EAC3C,uCAAuC;AACzC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,uCAAuC;EACvC,iCAAiC;AACnC;AACA;EACE,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,iDAAiD;AACnD;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;EACE,2CAA2C;EAC3C,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;EACtC,6CAA6C;AAC/C;AACA;EACE,6CAA6C;EAC7C,6CAA6C;EAC7C,mCAAmC;AACrC;AACA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;EACE,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,+CAA+C;AACjD;AACA;EACE,+CAA+C;EAC/C,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,gCAAgC;AAClC;AACA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,oCAAoC;AACtC;AACA;EACE,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,6CAA6C;AAC/C;AACA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,gCAAgC;AAClC;AACA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,+BAA+B;AACjC;AACA,yEAAyE;AACzE;EACE,6CAA6C;AAC/C;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;EAC5B,kCAAkC;EAClC,mBAAmB;AACrB;AACA;;EAEE,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,+DAA+D;AAC/D;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;qEAIqE;AACrE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,gDAAgD;EAChD,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;0DAE0D;AAC1D;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,uCAAuC;AACvC;EACE,kCAAkC;EAClC,oCAAoC;EACpC,yCAAyC;AAC3C;AACA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,sCAAsC;EACtC,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;AACA;EACE,mDAAmD;AACrD;AACA;EACE,wCAAwC;AAC1C;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C;EAC1C,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,kCAAkC;EAClC,iDAAiD;EACjD,+DAA+D;AACjE;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;AACA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;AACA;;EAEE,yCAAyC;EACzC,iBAAiB;EACjB,YAAY;AACd;AACA;;EAEE,UAAU;EACV,mCAAmC;AACrC;;AAEA,+CAA+C;AAC/C;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,uCAAuC;EACvC,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;;EAEE,oCAAoC;EACpC,0CAA0C;AAC5C;AACA;EACE,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,8CAA8C;EAC9C,2CAA2C;EAC3C,mCAAmC;AACrC;AACA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,uCAAuC;EACvC,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;;AAEA,uBAAuB;AACvB;EACE,kCAAkC;EAClC,sCAAsC;EACtC,mCAAmC;AACrC;AACA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;AACA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;;;;;;;;;;;;;;;mEAemE;AACnE;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,0CAA0C;EAC1C,0CAA0C;EAC1C,uCAAuC;EACvC,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA,kEAAkE;AAClE;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;;AAEA;;;;yEAIyE;AACzE;EACE,2CAA2C;AAC7C;AACA;EACE,8CAA8C;AAChD;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,6CAA6C;AAC/C;;AAEA,sCAAsC;AACtC;EACE,kCAAkC;EAClC,mCAAmC;EACnC,0CAA0C;EAC1C,0CAA0C;EAC1C,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,mCAAmC;AACrC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;;;EAGE,wCAAwC;EACxC,yCAAyC;EACzC,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA,uDAAuD;AACvD;;EAEE,kCAAkC;EAClC,wCAAwC;EACxC,0CAA0C;EAC1C,qDAAqD;EACrD,gCAAgC;EAChC,uCAAuC;EACvC,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA,oBAAoB;AACpB;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,uCAAuC;EACvC,6CAA6C;AAC/C;AACA;;;;;EAKE,sCAAsC;AACxC;;AAEA;;qEAEqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA,6EAA6E;AAC7E;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iGAAiG;AACnG;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,gCAAgC;AAClC;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;sEACsE;AACtE;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF;;AAEA,wDAAwD;AACxD;EACE,mCAAmC;EACnC,yBAAyB;AAC3B","sourcesContent":["/**\n * Global component layer — 2026 polish.\n * Restyles Bootstrap + the legacy pcoded template through design tokens only.\n * Loaded after theme.css; must work in BOTH html.light and html.dark.\n */\n\n/* === Base === */\nhtml {\n  font-family: var(--font-sans);\n}\n\nbody {\n  background: var(--page-bg) !important;\n  color: var(--foreground) !important;\n  font-family: var(--font-sans) !important;\n  transition: background-color var(--transition-slow), color var(--transition-slow);\n}\n\n::selection {\n  background: var(--primary-soft);\n  color: var(--foreground);\n}\n\n/* Custom scrollbars — thin, unobtrusive, theme-aware */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb) transparent;\n}\n*::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n*::-webkit-scrollbar-track {\n  background: transparent;\n}\n*::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: var(--radius-full);\n}\n*::-webkit-scrollbar-thumb:hover {\n  background: var(--scrollbar-thumb-hover);\n}\n\n/* Accessible focus — only for keyboard users */\n:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px var(--ring) !important;\n  border-radius: var(--radius-sm);\n}\n\nh1, h2, h3, h4, h5, h6 {\n  color: var(--foreground);\n  letter-spacing: -0.02em;\n  font-weight: 600;\n}\n\na {\n  color: var(--primary);\n  transition: color var(--transition-fast);\n}\na:hover {\n  color: var(--primary-hover);\n}\n\ncode, pre, .font-mono {\n  font-family: var(--font-mono);\n}\n\n/* === Layout wrapper === */\n/* Heights live in responsive.css (the shell is a flex column); this layer only\n   paints. */\n.labelflow-theme {\n  background: var(--page-bg);\n}\n\n.labelflow-main {\n  background: var(--page-bg);\n}\n\n.labelflow-container {\n  padding: 1.25rem;\n  max-width: 100%;\n}\n\n.pcoded-main-container {\n  background: var(--page-bg) !important;\n}\n\n/* === Header — frosted, sticky-feeling app bar === */\n.pcoded-header.navbar,\n.pcoded-header.header-dark,\n.pcoded-header.header-labelflow {\n  background: var(--header) !important;\n  color: var(--header-foreground) !important;\n  border-bottom: 1px solid var(--header-border) !important;\n  box-shadow: none !important;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.pcoded-header .input-group .input-group-text,\n.pcoded-header a,\n.pcoded-header .dropdown-toggle,\n.pcoded-header .h-drop {\n  color: var(--header-foreground) !important;\n  opacity: 0.85;\n  font-weight: 500;\n  transition: color var(--transition-fast), opacity var(--transition-fast);\n}\n\n.pcoded-header .input-group .input-group-text:hover,\n.pcoded-header a:hover,\n.pcoded-header .dropdown-toggle:hover,\n.pcoded-header .h-drop:hover {\n  color: var(--primary) !important;\n  opacity: 1;\n}\n\n.pcoded-header .dropdown-menu.profile-notification {\n  background: var(--popover) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: var(--radius) !important;\n  box-shadow: var(--shadow-lg) !important;\n  padding: 0.25rem !important;\n}\n\n.pcoded-header .dropdown-menu .dropdown-item {\n  color: var(--popover-foreground) !important;\n  border-radius: var(--radius-sm) !important;\n  padding: 0.5rem 0.75rem !important;\n  background: transparent !important;\n  transition: background-color var(--transition-fast);\n}\n\n.pcoded-header .dropdown-menu .dropdown-item:hover,\n.pcoded-header .dropdown-menu .dropdown-item:focus {\n  background: var(--accent) !important;\n  color: var(--accent-foreground) !important;\n}\n\n.pcoded-header .dropdown-menu .pro-head {\n  background: var(--muted) !important;\n  color: var(--foreground) !important;\n  border-bottom: 1px solid var(--border) !important;\n  padding: 0.75rem 1rem !important;\n  border-radius: var(--radius-sm) var(--radius-sm) 0 0 !important;\n}\n\n.pcoded-header .dropdown-menu .pro-body {\n  padding: 0.25rem !important;\n}\n\n.pcoded-header .drp-user .dropdown-toggle {\n  color: var(--header-foreground) !important;\n}\n.pcoded-header .drp-user .dropdown-toggle:hover {\n  color: var(--primary) !important;\n}\n\n/* === Containers === */\n.container,\n.container-fluid {\n  background: transparent !important;\n}\n\n/* === Cards === */\n.card {\n  background: var(--card) !important;\n  color: var(--card-foreground) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: var(--radius-lg) !important;\n  box-shadow: var(--shadow-sm) !important;\n  transition: border-color var(--transition), box-shadow var(--transition), transform var(--transition);\n}\n\n.card-header,\n.card .card-header {\n  background: transparent !important;\n  color: var(--foreground) !important;\n  border-bottom: 1px solid var(--border) !important;\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0 !important;\n  font-weight: 600;\n}\n\n.card-body {\n  background: transparent !important;\n  color: var(--card-foreground) !important;\n}\n\n/* The legacy theme hardcodes `.card .card-header h5 { color: white }` (and a\n   bare `h5 { color: white }`), which is invisible on a light card. The Card\n   atom's header renders exactly that h5, so titles must follow the token.\n   Specificity has to match the legacy `.card .card-header h5` to win. */\n.card .card-header h5,\n.card .card-header h6,\n.card-header h5,\n.card-header h6 {\n  color: var(--foreground) !important;\n}\n\n/* === Forms === */\n.form-control,\n.form-select,\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"password\"],\ninput[type=\"number\"],\ninput[type=\"search\"],\nselect,\ntextarea {\n  background: var(--background) !important;\n  border: 1px solid var(--input) !important;\n  border-radius: var(--radius-sm) !important;\n  color: var(--foreground) !important;\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.form-control::placeholder,\ntextarea::placeholder,\ninput::placeholder {\n  color: var(--muted-foreground) !important;\n  opacity: 0.8;\n}\n\n.form-control:focus,\n.form-select:focus,\ninput:focus,\nselect:focus,\ntextarea:focus {\n  border-color: var(--primary) !important;\n  box-shadow: 0 0 0 3px var(--ring) !important;\n  outline: none !important;\n  background: var(--card) !important;\n}\n\n/*\n * Opt-out for a text field that is NOT a standalone form control.\n *\n * The rules above are `!important`, so a page-level `border: none` on a textarea\n * loses to them silently. Where a field is only one part of a larger composed\n * surface that draws its own border and focus ring — the assistant composer — the\n * global chrome paints a second bordered box INSIDE that surface and stacks a\n * second focus ring on top of the parent's. Give such a field `lf-field-bare` and\n * let its container own the chrome. This is the supported way out; do not fight\n * the rules above with page-level `!important`.\n */\ntextarea.lf-field-bare,\ninput.lf-field-bare,\ntextarea.lf-field-bare:focus,\ninput.lf-field-bare:focus {\n  background: transparent !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.form-label,\nlabel {\n  color: var(--foreground);\n}\n\n.form-text,\nsmall.text-muted,\n.text-muted {\n  color: var(--muted-foreground) !important;\n}\n\n/* Switches & checks */\n.form-check-input {\n  background-color: var(--secondary) !important;\n  border-color: var(--border-strong) !important;\n}\n.form-check-input:checked {\n  background-color: var(--primary) !important;\n  border-color: var(--primary) !important;\n}\n.form-check-input:focus {\n  box-shadow: 0 0 0 3px var(--ring) !important;\n}\n.form-check-label {\n  color: var(--foreground);\n}\n\n/* Range sliders */\n.form-range::-webkit-slider-thumb {\n  background: var(--primary) !important;\n}\n.form-range::-moz-range-thumb {\n  background: var(--primary) !important;\n}\n.form-range::-webkit-slider-runnable-track {\n  background: var(--secondary) !important;\n  border-radius: var(--radius-full);\n}\n.form-range::-moz-range-track {\n  background: var(--secondary) !important;\n  border-radius: var(--radius-full);\n}\n\n/* === Buttons === */\n.btn {\n  border-radius: var(--radius-sm) !important;\n  font-weight: 500;\n  transition: all var(--transition-fast) !important;\n}\n.btn:active {\n  transform: translateY(1px);\n}\n.btn:focus,\n.btn:focus-visible {\n  box-shadow: 0 0 0 3px var(--ring) !important;\n}\n.btn:disabled {\n  opacity: 0.45;\n}\n\n.btn-primary {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n  color: var(--primary-foreground) !important;\n}\n.btn-primary:hover:not(:disabled) {\n  background: var(--primary-hover) !important;\n  border-color: var(--primary-hover) !important;\n  color: var(--primary-foreground) !important;\n}\n\n.btn-secondary {\n  background: var(--secondary) !important;\n  border-color: var(--border) !important;\n  color: var(--secondary-foreground) !important;\n}\n.btn-secondary:hover:not(:disabled) {\n  background: var(--secondary-hover) !important;\n  border-color: var(--border-strong) !important;\n  color: var(--foreground) !important;\n}\n.btn-secondary.active {\n  background: var(--primary-soft) !important;\n  border-color: var(--primary) !important;\n  color: var(--primary) !important;\n}\n\n.btn-success {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n  color: var(--primary-foreground) !important;\n}\n.btn-success:hover:not(:disabled) {\n  background: var(--primary-hover) !important;\n  border-color: var(--primary-hover) !important;\n}\n\n.btn-danger {\n  background: var(--destructive) !important;\n  border-color: var(--destructive) !important;\n  color: var(--destructive-foreground) !important;\n}\n.btn-danger:hover:not(:disabled) {\n  background: var(--destructive-hover) !important;\n  border-color: var(--destructive-hover) !important;\n}\n\n.btn-outline-success {\n  background: transparent !important;\n  border-color: var(--primary) !important;\n  color: var(--primary) !important;\n}\n.btn-outline-success:hover:not(:disabled) {\n  background: var(--primary-soft) !important;\n  color: var(--primary) !important;\n}\n.btn-outline-success.active {\n  background: var(--primary) !important;\n  color: var(--primary-foreground) !important;\n}\n\n.btn-outline-danger {\n  background: transparent !important;\n  border-color: var(--destructive) !important;\n  color: var(--destructive) !important;\n}\n.btn-outline-danger:hover:not(:disabled) {\n  background: var(--destructive-soft) !important;\n  color: var(--destructive) !important;\n}\n\n.btn-outline-secondary {\n  background: transparent !important;\n  border-color: var(--border-strong) !important;\n  color: var(--secondary-foreground) !important;\n}\n.btn-outline-secondary:hover:not(:disabled) {\n  background: var(--secondary) !important;\n  color: var(--foreground) !important;\n}\n\n.btn-outline-primary {\n  background: transparent !important;\n  border-color: var(--primary) !important;\n  color: var(--primary) !important;\n}\n.btn-outline-primary:hover:not(:disabled) {\n  background: var(--primary-soft) !important;\n  color: var(--primary) !important;\n}\n\n/* === Badges === */\n.badge {\n  border-radius: var(--radius-full) !important;\n  font-weight: 500;\n}\n.badge.bg-light {\n  background: var(--secondary) !important;\n  color: var(--secondary-foreground) !important;\n  border: 1px solid var(--border);\n}\n/* text-dark inside themed badges must follow the theme, not stay black */\n.badge.bg-light.text-dark {\n  color: var(--secondary-foreground) !important;\n}\n\n/* === Atom: Badge (components/Atoms/Badge.jsx) === */\n.lf-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.25rem 0.65rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  line-height: 1.2;\n  border-radius: var(--radius-full);\n  border: 1px solid var(--border);\n  background: var(--secondary);\n  color: var(--secondary-foreground);\n  white-space: nowrap;\n}\n.lf-badge--primary,\n.lf-badge--success {\n  background: var(--primary-soft);\n  color: var(--primary);\n  border-color: transparent;\n}\n.lf-badge--warning {\n  background: var(--warning-soft);\n  color: var(--warning);\n  border-color: transparent;\n}\n.lf-badge--info {\n  background: var(--info-soft);\n  color: var(--info);\n  border-color: transparent;\n}\n.lf-badge--danger {\n  background: var(--destructive-soft);\n  color: var(--destructive);\n  border-color: transparent;\n}\n.lf-badge--neutral {\n  background: var(--secondary);\n  color: var(--muted-foreground);\n}\n\n/* === Atom: IconButton (components/Atoms/IconButton.jsx) === */\n.lf-icon-btn {\n  background: transparent;\n  border: 1px solid var(--border);\n  color: var(--foreground);\n  width: 34px;\n  height: 34px;\n  border-radius: var(--radius-full);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n.lf-icon-btn:hover:not(:disabled) {\n  border-color: var(--primary);\n  color: var(--primary);\n  background: var(--primary-soft);\n}\n.lf-icon-btn--active {\n  border-color: var(--primary);\n  color: var(--primary);\n  background: var(--primary-soft);\n}\n.lf-icon-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* === Brand: the logo lockup (components/Atoms/Logo.jsx) ===\n   `--lf-logo-size` is set inline by the component and is the MARK's size; the\n   wordmark is derived from it so one number scales the whole lockup. Two-tone\n   on purpose: the accent belongs on the half that carries the name, and a\n   single emerald wordmark sat at poor contrast on the light theme. */\n.lf-logo {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.46em;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.lf-logo__mark {\n  display: block;\n  flex: 0 0 auto;\n  color: var(--primary);\n}\n\n.lf-logo__word {\n  font-family: var(--font-sans);\n  font-size: calc(var(--lf-logo-size, 26px) * 0.8);\n  font-weight: 700;\n  letter-spacing: -0.022em;\n}\n\n.lf-logo__word-label {\n  color: var(--foreground);\n}\n\n.lf-logo__word-flow {\n  color: var(--primary);\n}\n\n/* === Header: language switch (EN/KO) ===\n   Same pill geometry as .lf-icon-btn, but carries a text label instead of an\n   icon so the current language is readable at a glance. */\n.lf-lang-btn {\n  background: transparent;\n  border: 1px solid var(--border);\n  color: var(--foreground);\n  min-width: 34px;\n  height: 34px;\n  padding: 0 0.5rem;\n  border-radius: var(--radius-full);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-sans);\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n.lf-lang-btn:hover:not(:disabled) {\n  border-color: var(--primary);\n  color: var(--primary);\n  background: var(--primary-soft);\n}\n\n/* === Atom: ghost button variant === */\n.btn-ghost {\n  background: transparent !important;\n  border-color: transparent !important;\n  color: var(--muted-foreground) !important;\n}\n.btn-ghost:hover:not(:disabled) {\n  background: var(--secondary) !important;\n  color: var(--foreground) !important;\n}\n\n/* === Tables === */\n.table {\n  color: var(--foreground) !important;\n  --bs-table-bg: transparent;\n  --bs-table-color: var(--foreground);\n}\n.table thead th {\n  background: var(--muted) !important;\n  color: var(--muted-foreground) !important;\n  border-color: var(--border) !important;\n  font-weight: 600 !important;\n  text-transform: uppercase;\n  font-size: 0.72rem;\n  letter-spacing: 0.05em;\n}\n.table tbody td {\n  border-color: var(--border) !important;\n  color: var(--foreground) !important;\n}\n.table tbody tr {\n  transition: background-color var(--transition-fast);\n}\n.table tbody tr:hover {\n  background: var(--card-hover) !important;\n}\n\n/* === Modals === */\n.modal-backdrop.show {\n  background: var(--overlay) !important;\n  opacity: 1 !important;\n}\n.modal-content {\n  background: var(--card) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: var(--radius-lg) !important;\n  box-shadow: var(--shadow-lg) !important;\n  color: var(--foreground) !important;\n}\n.modal-header {\n  background: transparent !important;\n  border-bottom: 1px solid var(--border) !important;\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0 !important;\n}\n.modal-title {\n  color: var(--foreground) !important;\n}\n.modal-body {\n  background: transparent !important;\n  color: var(--foreground) !important;\n}\n.modal-footer {\n  background: transparent !important;\n  border-top: 1px solid var(--border) !important;\n}\n.modal .btn-close,\n.modal .close {\n  color: var(--muted-foreground) !important;\n  text-shadow: none;\n  opacity: 0.7;\n}\n.modal .btn-close:hover,\n.modal .close:hover {\n  opacity: 1;\n  color: var(--foreground) !important;\n}\n\n/* === Dropdown menus (generic bootstrap) === */\n.dropdown-menu {\n  background: var(--popover) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: var(--radius) !important;\n  box-shadow: var(--shadow-lg) !important;\n  color: var(--popover-foreground) !important;\n}\n.dropdown-item {\n  color: var(--popover-foreground) !important;\n}\n.dropdown-item:hover,\n.dropdown-item:focus {\n  background: var(--accent) !important;\n  color: var(--accent-foreground) !important;\n}\n.dropdown-divider {\n  border-color: var(--border) !important;\n}\n\n/* === Alerts === */\n.alert-success {\n  background: var(--primary-soft) !important;\n  border-color: var(--primary) !important;\n  color: var(--foreground) !important;\n}\n.alert-danger {\n  background: var(--destructive-soft) !important;\n  border-color: var(--destructive) !important;\n  color: var(--foreground) !important;\n}\n.alert-warning {\n  background: var(--warning-soft) !important;\n  border-color: var(--warning) !important;\n  color: var(--foreground) !important;\n}\n.alert-info {\n  background: var(--info-soft) !important;\n  border-color: var(--info) !important;\n  color: var(--foreground) !important;\n}\n\n/* === Progress === */\n.progress {\n  background: var(--secondary) !important;\n  border-radius: var(--radius-full) !important;\n}\n.progress-bar {\n  background-color: var(--primary) !important;\n}\n\n/* === Pagination === */\n.page-link {\n  background: var(--card) !important;\n  border-color: var(--border) !important;\n  color: var(--foreground) !important;\n}\n.page-link:hover {\n  background: var(--secondary) !important;\n  color: var(--primary) !important;\n}\n.page-item.active .page-link {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n  color: var(--primary-foreground) !important;\n}\n\n/* === Tippy tooltips (react-tippy) ===\n\n   THE BACKGROUND OVERRIDE BELOW DOES NOT PAINT ON ITS OWN, and that was the\n   bug. react-tippy defaults `animateFill: true`, which puts `data-animatefill`\n   on the tooltip — and the library's own rule\n   `.tippy-tooltip[data-animatefill]{background-color:transparent}` then wins,\n   because the visible fill is a SEPARATE `[x-circle]` element hardcoded to\n   #333. So the text colour followed the theme while the background never did.\n\n   In dark mode that passed unnoticed (#ecedee on #333 is 10.8:1). In LIGHT\n   mode it was #101418 on #333 — **1.46:1**, against a WCAG AA floor of 4.5.\n   The tooltip was effectively invisible, which is exactly how it was reported.\n\n   The atoms now pass `animateFill={false}`, so `.tippy-tooltip`'s own\n   background applies. `[x-circle]` is still tokenised here so the styling\n   stays correct if anyone ever turns the fill animation back on. */\n.tippy-tooltip {\n  background-color: var(--popover) !important;\n  color: var(--popover-foreground) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: var(--radius-sm) !important;\n  box-shadow: var(--shadow-md) !important;\n  font-family: var(--font-sans) !important;\n  font-size: 0.75rem !important;\n}\n\n/* Belt and braces: the animated fill, if it is ever re-enabled. */\n.tippy-tooltip[data-animatefill] {\n  background-color: var(--popover) !important;\n}\n.tippy-tooltip [x-circle] {\n  background-color: var(--popover) !important;\n}\n\n/* The arrow.\n   This used to target `.tippy-tooltip .arrow-regular` — a class that appears\n   NOWHERE in react-tippy, so it styled nothing. The real element is\n   `[x-arrow]`, and its colour lives on a border whose SIDE depends on the\n   placement, so one rule per placement is the only way to tokenise it. */\n.tippy-popper[x-placement^='top'] [x-arrow] {\n  border-top-color: var(--popover) !important;\n}\n.tippy-popper[x-placement^='bottom'] [x-arrow] {\n  border-bottom-color: var(--popover) !important;\n}\n.tippy-popper[x-placement^='left'] [x-arrow] {\n  border-left-color: var(--popover) !important;\n}\n.tippy-popper[x-placement^='right'] [x-arrow] {\n  border-right-color: var(--popover) !important;\n}\n\n/* === SweetAlert2 — token-aware === */\n.swal2-popup {\n  background: var(--card) !important;\n  color: var(--foreground) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: var(--radius-lg) !important;\n  box-shadow: var(--shadow-lg) !important;\n  font-family: var(--font-sans) !important;\n}\n.swal2-title {\n  color: var(--foreground) !important;\n}\n.swal2-html-container {\n  color: var(--muted-foreground) !important;\n}\n.swal2-toast {\n  background: var(--popover) !important;\n}\n.swal2-timer-progress-bar {\n  background: var(--primary) !important;\n}\n.swal2-input,\n.swal2-textarea,\n.swal2-select {\n  background: var(--background) !important;\n  border: 1px solid var(--input) !important;\n  color: var(--foreground) !important;\n  border-radius: var(--radius-sm) !important;\n}\n\n/* === AG Grid (Datatable) dark-compat via tokens === */\n.ag-theme-alpine,\n.ag-theme-alpine-dark {\n  --ag-background-color: var(--card);\n  --ag-foreground-color: var(--foreground);\n  --ag-header-background-color: var(--muted);\n  --ag-header-foreground-color: var(--muted-foreground);\n  --ag-border-color: var(--border);\n  --ag-row-hover-color: var(--card-hover);\n  --ag-odd-row-background-color: transparent;\n  --ag-control-panel-background-color: var(--card);\n}\n\n/* === Utility === */\n.no_data {\n  background: var(--muted) !important;\n  color: var(--muted-foreground) !important;\n}\n\n.text-primary {\n  color: var(--primary) !important;\n}\n.bg-light {\n  background: var(--secondary) !important;\n  color: var(--secondary-foreground) !important;\n}\n.border,\n.border-top,\n.border-bottom,\n.border-start,\n.border-end {\n  border-color: var(--border) !important;\n}\n\n/* === Labeling toolbar (labelManagement studios) ===\n   Grouped icon/label controls shared by the detection, segmentation and\n   classification workspaces. Tokens only — checked in both themes. */\n.lf-toolbar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  width: 100%;\n}\n.lf-toolbar__spacer {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n.lf-toolbar__group {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 3px;\n  background: var(--muted);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n}\n/* react-tippy wraps every Button atom in a div — keep it out of the layout */\n.lf-toolbar__group > div {\n  display: flex;\n}\n.lf-tool-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  height: 32px;\n  padding: 0 0.6rem;\n  border: 1px solid transparent;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--foreground);\n  font-size: 0.8rem;\n  font-weight: 500;\n  line-height: 1;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background var(--transition), color var(--transition), border-color var(--transition);\n}\n.lf-tool-btn i {\n  font-size: 0.85rem;\n}\n.lf-tool-btn--icon {\n  width: 32px;\n  padding: 0;\n}\n.lf-tool-btn--ratio {\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  letter-spacing: 0.02em;\n}\n.lf-tool-btn:hover:not(:disabled) {\n  background: var(--accent);\n  color: var(--accent-foreground);\n}\n.lf-tool-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--ring);\n}\n.lf-tool-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.lf-tool-btn--active {\n  background: var(--primary);\n  border-color: var(--primary);\n  color: var(--primary-foreground);\n}\n.lf-tool-btn--active:hover:not(:disabled) {\n  background: var(--primary-hover);\n  border-color: var(--primary-hover);\n  color: var(--primary-foreground);\n}\n.lf-zoom-readout,\n.lf-image-counter {\n  min-width: 3.75rem;\n  padding: 0 0.25rem;\n  text-align: center;\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  font-variant-numeric: tabular-nums;\n  color: var(--muted-foreground);\n  user-select: none;\n}\n.lf-toolbar__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--primary);\n}\n\n/* Below this width the toolbar would wrap to two rows — drop the word labels\n   and keep the icons, which stay understandable via their tooltips. */\n@media (max-width: 1400px) {\n  .lf-tool-btn__label {\n    display: none;\n  }\n  .lf-tool-btn {\n    width: 32px;\n    padding: 0;\n  }\n}\n\n/* Destructive variant of the labeling toolbar button. */\n.lf-tool-btn--danger:hover:not(:disabled) {\n  background: var(--destructive-soft);\n  color: var(--destructive);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
